import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Sidebar = () => {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  // إذا لم يكن مسجلاً دخول، لا تظهر السايدبار أبداً
  if (!isAuthenticated) {
    return null;
  }

  const menuItems = [
    { icon: 'fa-chart-line', label: 'Dashboard Overview', path: '/dashboard' },
    { icon: 'fa-image', label: 'My Collection', path: '/dashboard/collection' },
    { icon: 'fa-handshake', label: 'Offers & Orders', path: '/dashboard/offers' },
    { icon: 'fa-file-invoice', label: 'Invoices & Payments', path: '/dashboard/invoices' },
    { icon: 'fa-calendar-days', label: 'Exhibitions & Events', path: '/dashboard/events' },
    { icon: 'fa-bell', label: 'Notifications', path: '/dashboard/notifications' },
    { icon: 'fa-chart-bar', label: 'Reports & Insights', path: '/dashboard/reports' },
    { icon: 'fa-user-check', label: 'Following', path: '/dashboard/following' },
  ];

  const bottomMenuItems = [
    { icon: 'fa-gear', label: 'Account & Settings', path: '/dashboard/settings' },
    { icon: 'fa-circle-question', label: 'Support', path: '/dashboard/support' },
  ];

  return (
    <div className="hidden lg:block">
      <aside className="fixed lg:relative top-0 left-0 h-full w-64 bg-white border-r border-gray-100 flex flex-col">
      
        
        <nav className="flex-1 px-4 py-6 space-y-1 overflow-y-auto">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center space-x-3 px-4 py-3 hover:bg-gallery-gray rounded text-sm transition-all duration-200 ${
                location.pathname === item.path 
                  ? 'bg-gallery-gray text-black' 
                  : 'text-gray-700 hover:text-black'
              }`}
            >
              <i className={`fa-solid ${item.icon} w-5 text-xs`}></i>
              <span className="font-normal">{item.label}</span>
            </Link>
          ))}
          
          <div className="pt-6 mt-6 border-t border-gray-100">
            {bottomMenuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded text-sm transition-all duration-200 ${
                  location.pathname === item.path 
                    ? 'bg-gallery-gray text-black' 
                    : 'text-gray-700 hover:bg-gallery-gray hover:text-black'
                }`}
              >
                <i className={`fa-solid ${item.icon} w-5 text-xs`}></i>
                <span className="font-normal">{item.label}</span>
              </Link>
            ))}
          </div>
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;